module.exports = __webpack_public_path__ + "img/logo-sena-naranja.43e61d0f.svg";